import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import Share from "./Share";
import DescriptionRenderer from "./DescriptionRenderer";
import BlogMovieList from "./BlogMovieList";

function removeUnmatchedClosingPTags(html) {
  let openCount = 0;
  return html.replace(/<\/?p>/gi, (match) => {
    if (match.toLowerCase() === "<p>") {
      openCount++;
      return match;
    } else if (match.toLowerCase() === "</p>") {
      if (openCount > 0) {
        openCount--;
        return match;
      } else {
        // Unmatched </p>, remove it
        return "";
      }
    }
    return match;
  });
}
function BlogDetailsPage(data) {
  let listData = data.data;

  const extractMovieInfo = (_text) => {
    const text = _text.split("\r\n").join("");
    const startTag = "${movie_info_start}";
    const endTag = "${movie_info_end}";

    const startIdx = text.indexOf(startTag);
    const endIdx = text.indexOf(endTag);

    if (startIdx === -1 || endIdx === -1) return null;

    let jsonText = text.slice(startIdx + startTag.length, endIdx).trim();
    console.log(jsonText);
    jsonText = removeUnmatchedClosingPTags(jsonText);
    console.log(jsonText);

    try {
      // Decode any HTML entities if needed here
      const cleanedJsonText = jsonText
        .replace(/&quot;/g, '"')
        .replace(/&nbsp;/g, " ")
        .replace(/<br\s*\/?>/gi, "")
        //.replace(/<p>\s*<\/p>/gi, "")
        //.replace(/<p>/gi, "")
        //.replace(/<\/p>/gi, "\n")
        .replace(/\\r\\n/g, "")
        .replace(/^\s*{\s*/g, "{") // clean opening
        .replace(/\s*}\s*$/g, "}"); // clean closing

      console.log(cleanedJsonText);

      let cleanedJsonTextP = cleanedJsonText
        .replace(/&lt;p&gt;/g, "<p>")
        .replace(/&lt;\/p&gt;/g, "</p>");
      console.log(cleanedJsonTextP);

      return JSON.parse(cleanedJsonTextP);
    } catch (error) {
      console.error("Failed to parse JSON:", error);
      return null;
    }
  };
  const getFooterContent = (listData) => {
    if (listData.footer_title) {
      return listData.footer_title;
    } else {
      let input = listData.description;
      if (
        input.includes("${footer_content_start}") &&
        input.includes("${footer_content_end}")
      ) {
        const match = input.match(
          /\${footer_content_start}(.*?)\${footer_content_end}/s
        );
        const content = match ? match[1].trim() : "";
        return content;
      } else {
        return "";
      }
    }
  };
  const movieInfo = extractMovieInfo(listData.description);
  let movieListData = null;
  if (movieInfo) {
    movieListData = {
      movie_info: movieInfo,
    };
  }

  console.log(movieInfo);

  return (
    <section className="container blog-posts">
      <div className="row mt-2">
        <div className="blogstuff-de">
          <DescriptionRenderer listData={listData} />
        </div>
        <BlogMovieList listData={listData}></BlogMovieList>
        {movieInfo ? (
          <BlogMovieList listData={movieListData}></BlogMovieList>
        ) : (
          ""
        )}

        <div className="blogstuff-de">
          <div
            dangerouslySetInnerHTML={{ __html: getFooterContent(listData) }}
          />
        </div>
        <div className="d-flex align-items-center mt-5">
          <a href={listData?.author?.url} target="_blank">
            <img
              style={{ width: "1em", marginBottom: "0" }}
              src="./assets/images/ico-linkedin.svg"
              alt="LinkedIn"
            />
          </a>

          <a
            href={listData?.author?.url}
            target="_blank"
            className="author-link"
          >
            <span className="blog-author" style={{ marginLeft: "0.5em" }}>
              by: {listData?.author?.name}
            </span>
          </a>
        </div>
      </div>
    </section>
  );
  function getDisplayTitle(item) {
    let displayTitle = item.movie_title;
    if (item.movie_display_title) {
      displayTitle = item.movie_display_title;
    }
    return displayTitle;
  }
  function getBlogLaunchUrl(item) {
    let urlFull = window.location.href;
    let url = urlFull;
    let qs = "";
    if (urlFull.indexOf("?") > -1) {
      url = urlFull.split("?")[0];
      qs = "?" + urlFull.split("?")[1];
    }
    let newUrl = url.replace(/\/#\/?$/, "");
    newUrl = window.location.protocol + "//" + window.location.hostname;
    let title = getCleanedTitle(item.movie_title);
    let nodeId = item.node_id;
    let base = "/";
    let itemType = "movies";
    if (item.itemType && item.itemType.toLowerCase() === "tv-shows") {
      itemType = "tv-shows";
    } else if (item.itemType && item.itemType.toLowerCase() === "category") {
      itemType = "category";
    } else if (item.itemType && item.itemType.toLowerCase() === "shows") {
      itemType = "shows";
    }
    //itemType = "tv-shows";
    let moviePath = `${itemType}/${nodeId}/${title}`;
    let moviePathWithSlash = base + moviePath;
    if (!newUrl.endsWith("/")) {
      moviePath = moviePathWithSlash;
    }
    let baseUrl = document.location.origin;
    //window.location.href = baseUrl + moviePath + qs;
    return baseUrl + moviePath + qs;
  }
  function getCleanedTitle(str) {
    str = str.toLowerCase().split(" ").join("-");
    /*// Replace all non-alphanumeric characters except hyphens with an empty string
		str = str.replace(/[^\w-]+/g, '-');
		// Replace consecutive hyphens with a single hyphen
		str = str.replace(/-{2,}/g, '-');
		return str;*/
    // Remove all non-alphanumeric characters except hyphens
    str = str.replace(/[^\w-]/g, "");
    // Remove consecutive hyphens
    str = str.replace(/-{2,}/g, "-");
    // Remove trailing hyphen (if present)
    str = str.replace(/-$/, "");
    return str;
  }
  function getImageUrl(item) {
    let imageUrl = `${window.cdnBaseUrl}${item.movie_image}`;
    return imageUrl;
  }
  function renderList(info) {
    return (
      <>
        <h2
          className="mb-4 list-title"
          dangerouslySetInnerHTML={{ __html: info.title }}
        />
        {info.list.length > 0 &&
          info.list.map((item, index) => {
            return [
              index % 2 === 0 ? (
                <article className="blog-de-post" key={index}>
                  <div className="blog-de-post-container row">
                    <div className="blog-de-post-image col-md-3 col-sm-12">
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="gtm-lp gtm-blog-thumbnail"
                      >
                        <img src={getImageUrl(item)} alt={item.movie_title} />
                      </a>
                    </div>
                    <div className="blog-de-post-content col-md-9 col-sm-12">
                      <div className="blog-de-post-header">
                        <h2>{getDisplayTitle(item)}</h2>
                        {item.movie_sub_title ? (
                          <h2>{item.movie_sub_title}</h2>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="blogstuff-de mb-4 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.movie_description,
                          }}
                        />
                      </div>
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="btn btn-primary gtm-lp gtm-blog-watch-now"
                      >
                        Watch Now
                      </a>
                      {/* &nbsp;&nbsp;
                      <div className="share-container blog-list">
                        <Share
                          url={getBlogLaunchUrl(item)}
                          msg={"Watch%20Now%20On%20Fawesome"}
                        ></Share>
                      </div> */}
                    </div>
                  </div>
                </article>
              ) : (
                <article className="blog-de-post" key={index}>
                  <div className="blog-de-post-container row">
                    <div className="blog-de-post-content col-md-9 col-sm-12">
                      <div className="blog-de-post-header">
                        <h2>{getDisplayTitle(item)}</h2>
                        {item.movie_sub_title ? (
                          <h2>{item.movie_sub_title}</h2>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="blogstuff-de mb-4 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.movie_description,
                          }}
                        />
                      </div>
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="btn btn-primary gtm-lp gtm-blog-watch-now"
                      >
                        Watch Now
                      </a>
                      {/* &nbsp;&nbsp;
                      <div className="share-container blog-list">
                        <Share
                          url={getBlogLaunchUrl(item)}
                          msg={"Watch%20Now%20On%20Fawesome"}
                        ></Share>
                      </div> */}
                    </div>
                    <div className="blog-de-post-image col-md-3 col-sm-12">
                      <a
                        href={getBlogLaunchUrl(item)}
                        className="gtm-lp gtm-blog-thumbnail"
                      >
                        <img src={getImageUrl(item)} alt={item.movie_title} />
                      </a>
                    </div>
                  </div>
                </article>
              ),
            ];
          })}
      </>
    );
  }
}

export default BlogDetailsPage;
